import React from 'react'

import Table from './Table'

const Payments = () => {
  return <Table />
}

export default Payments
